"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import { Link } from 'react-router-dom';
import ticketImg1 from '../../assets/images/resources/buy-ticket-img.jpg'

export default function BuyTicket() {
  // State for dynamic content
  const [brandContent] = useState({
    qualityPromise: "Quality Guaranteed - Professional results you can trust",
    deliveryPromise: "On-Time Delivery - When you need it, where you need it",
    title: "Ready to Make Your Brand Unforgettable?",
    description:
      "Every successful business knows that brand recognition drives growth. But many settle for generic promotional products that get forgotten instantly. Your brand deserves promotional materials that create lasting impressions, build customer loyalty, and deliver measurable ROI.",
    buttons: [
      { id: 1, text: "Get Free Quote", link: "/contact", class: "buy-ticket__btn-1" },
    ],
    brandImage: ticketImg1,
  });

  return (
    <>
      {/* Buy Ticket Start */}
      <section className="buy-ticket">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div
                className="buy-ticket__left wow fadeInLeft"
                data-wow-delay="100ms"
              >
                <ul className="buy-ticket__address list-unstyled">
                  <li>
                    <div className="icon">
                      <span className="icon-clock"></span>
                    </div>
                    <div className="text">
                      <p>{brandContent.qualityPromise}</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span className="icon-pin"></span>
                    </div>
                    <div className="text">
                      <p>{brandContent.deliveryPromise}</p>
                    </div>
                  </li>
                </ul>
                <h3 className="buy-ticket__title">{brandContent.title}</h3>
                <p className="buy-ticket__text">{brandContent.description}</p>
                <div className="buy-ticket__btn-box">
                  {brandContent.buttons.map((button) => (
                    <Link
                      key={button.id}
                      to={button.link}
                      className={`${button.class} thm-btn`}
                    >
                      {button.text}
                      <span className="icon-arrow-right"></span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Buy Ticket End */}
    </>
  );
} 